<template>
  <b-overlay variant="success" :opacity="0.5" :show="wait">
    <b-modal @show="setNull" v-model="verPrePago">
      <template #modal-header>Pago</template>

      <b-input-group size="sm" class="mt-2">
        <template #prepend>
          <b-input-group-text class="py-1 px-2 uniforme">Total </b-input-group-text>
        </template>
        <label v-html="GranTotal" class="form-control" />
      </b-input-group>

      <b-input-group size="sm" class="mt-2">
        <template #prepend>
          <b-input-group-text class="py-1 px-2 uniforme">Responsable </b-input-group-text>
        </template>
        <select v-model="Responsable" class="form-control select-custom">
          <option :value="envio.Envia">Envia</option>
          <option :value="envio.Recibe">Recibe</option>
        </select>
      </b-input-group>

      <b-form-group :state="stPago" :invalid-feedback="txtPago" :description="Conversion(GranTotal)">
        <b-input-group size="sm" class="mt-2">
          <template #prepend>
            <b-input-group-text class="py-1 px-2 uniforme bg-success text-white">Pago</b-input-group-text>
          </template>
          <b-form-input :state="stPago" type="number" v-model="Pago" />
        </b-input-group>
      </b-form-group>

      <template #modal-footer>
        <b-button @click="verPrePago = false">Cerrar</b-button>
        <b-button :disabled="!Pago" @click="guardarEnvio(1)" variant="success">Guardar</b-button>
      </template>
    </b-modal>

    <b-card v-if="!EnvioFecha == false">
      <b-row>
        <b-col> <h6>Envios</h6> </b-col>
        <b-col class="gradiente p-2 text-center">
          <h6>{{ EnvioFecha }}</h6>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-input-group size="sm" class="mt-2">
            <b-form-input size="sm" id="nombre" v-model="Remitente.Nombre" class="mb-2 mr-sm-2 mb-sm-0" placeholder="Cliente Envia" />
            <b-input-group-append>
              <get-cliente @Respuesta="onRespuestaEnvia" />
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col md="6">
          <b-input-group size="sm" class="mt-2 input-group-merge">
            <label class="form-control sm" v-html="Destinatario.Nombre"></label>
            <b-input-group-append>
              <get-cliente @Respuesta="onRespuestaRecibe" />
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <ContenidoEnvio v-model="tmpEnvio.Contenido" :tipoCambio="tipoCambio" v-if="verContenido" />

      <div v-show="SubTotal > 0">
        <b-row>
          <b-col md="6">
            <b-input-group class="my-2">
              <template #prepend>
                <b-input-group-text class="py-1 px-2 uniforme"> Entrega </b-input-group-text>
              </template>
              <div class="selectWrapper form-control form-control-sm">
                <select v-model="Entrega">
                  <option v-for="r in Repartidores" :key="r.Codigo" :value="r.Codigo" v-html="r.Nombre"></option>
                </select>
              </div>
            </b-input-group>
          </b-col>
          <b-col md="6">
            <b-input-group size="sm" class="mt-2">
              <template #prepend>
                <b-input-group-text class="py-1 px-2 uniforme"> Referencia </b-input-group-text>
              </template>
              <b-form-input v-model="Referencia" />
            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-input-group size="sm" class="mt-2">
              <template #prepend>
                <b-input-group-text class="py-1 px-2 uniforme">
                  Impuesto
                </b-input-group-text>
              </template>
              <b-form-input type="number" v-model="Impuesto" />
            </b-input-group>
          </b-col>
          <b-col md="6">
            <b-input-group size="sm" class="mt-2">
              <template #prepend>
                <b-input-group-text class="py-1 px-2 uniforme">Valorado</b-input-group-text>
              </template>
              <b-form-input type="number" v-model="Valorado" />
            </b-input-group>
          </b-col>
        </b-row>

        <b-input-group size="sm" class="mt-2">
          <template #prepend>
            <b-input-group-text class="py-1 px-2 uniforme">Sub Total</b-input-group-text>
          </template>
          <label v-html="subTotal" class="form-control"></label>
        </b-input-group>

        <b-input-group size="sm" class="mt-2">
          <template #prepend>
            <b-input-group-text class="py-1 px-2 uniforme">Total </b-input-group-text>
          </template>
          <label v-html="GranTotal" class="form-control" />
        </b-input-group>

     
        <b-input-group size="sm" class="mt-2">
          <template #prepend>
            <b-input-group-text class="py-1 px-2 uniforme"> Observaciones </b-input-group-text>
          </template>
          <b-form-textarea size="sm" v-model="Observacion" placeholder="Observaciones"></b-form-textarea>
        </b-input-group>
      </div>
      <b-row class="mt-2">
        <b-col></b-col>
        <b-col cols="auto">
          <b-button @click="LimpiarEnvio" class="mx-2" variant="primary">Limpiar</b-button>
          <b-button :disabled="!aplica" @click="guardarEnvio(0)" variant="success">{{ Editando ? "Actualizar Envio" : "Guardar Envio" }} </b-button>
        </b-col>
      </b-row>
    </b-card>
    <div v-else>
      <b-container>
        <b-card>
          <template #header>
            <h4><b-icon-info-square-fill variant="danger" /> Información!</h4>
          </template>

          <b-card-body>
            <h5>No hay viaje disponible !!</h5>
          </b-card-body>
        </b-card>
      </b-container>
    </div>
  </b-overlay>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";
import getCliente from "./getCliente.vue";
import ContenidoEnvio from "./ContenidoEnvio.vue";

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();
var fecha = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
fecha.setDate(fecha.getDate() - 1);

function NoGuia() {
  let rs = "" + (Math.floor(Math.random() * 8) + 1);
  for (let i = 0; i < 11; i++) {
    rs += Math.floor(Math.random() * 9);
  }
  return rs;
}
let cargado = false;
let txtEnvio = "";

// - - - - - - - - - - - - - - - - - - - INICIO DEL EXPORT - - - - - - - - - - - - - - - - - - - - - - -
export default {
  props: ["NumeroEnvio"],
  watch: {
    Parametros(v) {
      if (v.length > 0) {
        let tmp = v.filter((dato) => {
          return dato.id == "TipoCambio";
        });
        this.tipoCambio = tmp[0].valor;
      }
    },
    Responsable(v) {
      this.tmpEnvio.Responsable = v;
    },
    Pago(v) {
      this.tmpEnvio.Pago = v;
    },
    Observacion(v) {
      this.tmpEnvio.Observacion = v;
    },
    Entrega(v) {
      this.tmpEnvio.Entrega = v;
    },
    tmpEnvio: {
      handler(valor) {
        if (cargado) {
          localStorage.Envio = JSON.stringify(valor);
        }
      },
      deep: true,
    },
    Referencia(v) {
      this.tmpEnvio.Referencia = v.toUpperCase();
    },
    Viajes(v) {
      if (v[0]) {
        let f = new Date(v[0].fecha);
        let sig = {
          ...v[0],
          id: v[0].id,
          precio: v[0].precio,
          fecha: f.toLocaleDateString("es-ES", {
            weekday: "long",
            day: "numeric",
            month: "long",
          }),
        };
        this.siguienteViaje = sig;
        this.tmpEnvio.Viaje = v[0].id;
      }
    },
    subTotal(cs) {
      console.log(typeof cs);
      if (this.Impuesto && this.Impuesto != "") {
        this.GranTotal += parseFloat(this.Impuesto);
      } else {
        this.GranTotal = cs;
      }
      this.tmpEnvio.GranTotal = this.GranTotal;
    },

    Impuesto(v) {
      if (v && v != "") {
        this.GranTotal = parseFloat(this.subTotal) + parseFloat(v);
      } else {
        this.GranTotal = parseFloat(this.subTotal);
      }
      this.tmpEnvio.Impuesto = parseFloat(v);
      this.tmpEnvio.GranTotal = this.GranTotal;
    },
    Valorado(v) {
      this.tmpEnvio.Valorado = v;
    },
    Destinatario(v) {
      this.Responsable = v.id;
    },
  },
  destroyed() {
    let edit = this.Editando;
    if (edit) localStorage.removeItem("Envio");
  },

  mounted() {
    this.$watch("tmpEnvio.Contenido", this.wchContenido);
    txtEnvio = JSON.stringify(this.tmpEnvio);
    let tmp = JSON.parse(localStorage.Envio || txtEnvio);
    let viajes = JSON.parse(localStorage.Viajes);
    this.Viajes = viajes.filter((v) => new Date(v.fecha) > fecha);
    this.tmpEnvio = tmp;
    this.Remitente = tmp.Remitente;
    this.Destinatario = tmp.Destinatario;
    let gia = tmp.NoGuia || NoGuia();
    this.NoGuia = gia;
    this.tmpEnvio.NoGuia = gia;
    this.tmpEnvio.Fecha = new Date();
    this.Impuesto = tmp.Impuesto;
    this.Valorado = tmp.Valorado;
    this.Referencia = tmp.Referencia;
    this.Observacion = tmp.Observacion;
    this.Pago = tmp.Pago;
    this.FechaEnvio = new Date(tmp.FechaEnvio);
    this.Editando = !tmp.IdEnvio == false;
    this.IdEnvio = tmp.IdEnvio;
    cargado = true;
    this.wait = false;
  },
  data() {
    return {
      verPrePago: false,
      tipoCambio: 7.7,
      IdEnvio: null,
      FechaEnvio: new Date(),
      Envios: [],
      wait: true,
      Responsable: "ninguno",
      Repartidores: null,
      Pago: null,
      tmpEnvio: {
        Pago: null,
        Fecha: null,
        NoGuia: null,
        Viaje: null,
        SubTotal: null,
        Impuesto: null,
        GranTotal: null,
        Valorado: null,
        Referencia: "",
        Contenido: [],
        Remitente: {},
        Destinatario: { Nombre: "Cliente recibe" },
        Entrega: "DVE",
        Receptor: {},
        Observacion: null,
        Responsable: null,
      },
      Referencia: "",
      subTotal: null,
      GranTotal: null,
      Entrega: "DVE",
      ver: false,
      Prod: { Producto: null },
      Remitente: {},
      Destinatario: { Nombre: "Cliente recibe" },
      modalEnvia: false,
      Entregado: false,
      Valorado: null,
      Impuesto: "",
      Viajes: null,
      rs: {},
      Parametros: null,
      NoGuia: null,
      FechaTemp: null,
      siguienteViaje: {},
      Observacion: null,
      Clientes: null,
      Editando: false,
    };
  },
  computed: {
    EnvioFecha() {
      let f = this.Editando
        ? this.FechaEnvio.toLocaleDateString("es-ES", {
            weekday: "long",
            day: "numeric",
            month: "long",
          })
        : this.siguienteViaje.fecha;
      return f;
    },
    tc() {
      return this.tipoCambio || 0.0;
    },
    verResponsable() {
      return this.Pago != this.GranTotal;
    },
    txtPago() {
      if (this.tmpEnvio.Pago > this.tmpEnvio.GranTotal) {
        return "Monto mayor al Total!";
      } else return "Monto incorrecto!";
    },
    stPago() {
      return this.tmpEnvio.Pago >= 0 && this.tmpEnvio.Pago <= this.tmpEnvio.GranTotal;
    },
    aplica() {
      let gt = this.tmpEnvio.GranTotal;
      let pg = this.tmpEnvio.Pago;
      let t = gt > 0;
      let p = pg >= 0 && pg <= gt;
      let rs = t && p;
      return rs;
    },
    SubTotal() {
      let cs = 0;
      let datos = this.tmpEnvio.Contenido;
      datos.forEach((c) => {
        cs += parseFloat(c.Cobro);
      });
      return cs.toFixed(2);
    },
    Contenido() {
      let rs = this.tmpEnvio.Contenido;

      console.log("Cambio contenido");
      return rs;
    },
    verContenido() {
      let e = this.envio.Envia;
      let r = this.envio.Recibe;
      return e && r;
    },
    envio() {
      let tmp = { ...this.tmpEnvio };
      tmp.Envia = tmp.Remitente.id || "";
      tmp.Recibe = tmp.Destinatario.id || "";
      delete tmp.Remitente;
      delete tmp.Destinatario;
      return tmp;
    },
  },
  methods: {
    setNull() {
      this.Pago = null;
    },
    wchContenido(v) {
      let cs = 0;
      if (v.length > 0) {
        v.forEach((c) => {
          cs += parseFloat(c.Cobro);
        });
        this.subTotal = cs;
        this.tmpEnvio.SubTotal = cs;
        this.Pago = cs;
      } else {
        this.subTotal = 0;
        this.tmpEnvio.SubTotal = 0;
      }
    },
    Conversion(dolares) {
      if (dolares > 0) return "Quetzales: " + (dolares * this.tipoCambio).toFixed(2);
      else "";
    },
    LimpiarEnvio() {
      let gia = NoGuia();
      let n = JSON.parse(txtEnvio);
      n.Fecha = new Date();
      this.NoGuia = gia;
      n.NoGuia = gia;
      n.Viaje = this.siguienteViaje.id;
      this.Remitente = n.Remitente;
      this.Destinatario = n.Destinatario;
      this.tmpEnvio = n;
      this.tmpEnvio.Contenido.splice(0);
      this.Impuesto = 0;

      localStorage.removeItem("Envio");
      localStorage.removeItem("Pak");
      this.Editando = false;
      console.log("limpio...");
    },
    addEnvio() {
      this.wait = true;
      let dato = { ...this.envio };
      let DB = db.collection("Envios");

      dato = JSON.parse(JSON.stringify(dato));
      dato.Fecha = new Date(dato.Fecha);

      DB.add(dato).then((dato) => {
        let n = dato.id;
        if (this.verResponsable) {
          let deuda = this.GranTotal - this.Pago;

          let cliente = this.Remitente.id == this.Responsable ? this.Remitente : this.Destinatario;
          let ac = cliente.Deuda || 0;
          db.collection("Cliente")
            .doc(cliente.id)
            .update({ Deuda: ac + deuda })
            .then(() => {
              this.redireccionar(n);
            });
        } else {
          this.redireccionar(n);
        }
      });
    },
    updateEnvio() {
      this.wait = true;
      let dato = { ...this.envio };
      let DB = db.collection("Envios");

      let id = this.envio.IdEnvio;
      delete dato.IdEnvio;

      dato = JSON.parse(JSON.stringify(dato));
      dato.Fecha = new Date(dato.Fecha);

      DB.doc(id)
        .set(dato)
        .then(() => {
          this.wait = false;
          this.$bvModal.msgBoxConfirm("El envio fue actualizado!");
        });
    },
    guardarEnvio(nivel) {
      

      if (nivel == 1) {
        
        this.addEnvio();
      } else {
        if (this.Editando) this.updateEnvio();
        else this.verPrePago = true;
      }
    },
    redireccionar(n) {
      localStorage.removeItem("Envio");
      this.LimpiarEnvio();

      let env = {
        ...this.Envios.filter((d) => {
          return d.id == n;
        }),
      }[0];

      env.Remitente = this.Clientes.filter((p) => p.id == env.Envia)[0];
      env.Destinatario = this.Clientes.filter((p) => p.id == env.Recibe)[0];

      localStorage.Paquete = JSON.stringify(env);
      localStorage.Viaje = JSON.stringify(this.Viajes[0]);
      this.$router.push("/Envio");
    },

    onRespuestaEnvia(rs) {
      this.Remitente = rs;
      this.tmpEnvio.Remitente = rs;
    },
    onRespuestaRecibe(rs) {
      this.Destinatario = rs;
      this.tmpEnvio.Destinatario = rs;
    },
  },
  components: { getCliente, ContenidoEnvio },
  firestore: {
    Envios: db.collection("Envios"),
    Parametros: db.collection("Parametros"),
    Repartidores: db.collection("Repartidor"),
    Clientes: db.collection("Cliente"),
  },
};
</script>

<style scoped>
.gradiente {
  background-image: linear-gradient(to right, white, #e88a3f);
}

.uniforme {
  width: 120px;
}
.selectWrapper {
  overflow: hidden;
  position: relative;
  border: 1px solid #bbb;
  border-radius: 2px;
  background: #ffffff url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2211%22%20height%3D%2211%22%20viewBox%3D%220%200%2011%2011%22%3E%3Cpath%20d%3D%22M4.33%208.5L0%201L8.66%201z%22%20fill%3D%22%2300AEA9%22%2F%3E%3C%2Fsvg%3E") right 13px center no-repeat;
}
.selectWrapper select {
  font-size: 16px;
  line-height: 18px;
  width: 100%;
  border: none;
  box-shadow: none;
  background: transparent;
  background-image: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
  -moz-appearance: none;
  text-indent: 0.01px;
  text-overflow: ellipsis;
}
</style>
